import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

    constructor(
      private cookieService: CookieService,
      private messageService: MessageService,
      private translate: TranslateService
    ) {

    }

  intercept(req: HttpRequest<any>, next: HttpHandler):   Observable<HttpEvent<any>> {
    // We retrieve the token, if any
    const token = this.cookieService.get('nomad.noc.ng.token');
    let newHeaders = req.headers;
    if (token) {
       // If we have a token, we append it to our new headers
       newHeaders = newHeaders.append('Auth-Token', token);
    }
    // Finally we have to clone our request with our new headers
    // This is required because HttpRequests are immutable
    const authReq = req.clone({headers: newHeaders});
    // Then we return an Observable that will run the request
    // or pass it to the next interceptor if any
    return next.handle(authReq).pipe(
      catchError(error => {
          //default case: print, log, toast, etc...
          this.messageService.add({
            key: 'apiError',
            severity:'error', 
            summary: this.translate.instant('I18N_GENERAL.API_ERROR'),
            detail: error.message || error
          });
          return throwError(error.message || error);
      })
    )
  }
}
